// Danh sách 18 khoá — CHỈ liệt kê MỘT LẦN duy nhất ở đây. `FeatureKey` và `FEATURES` bên dưới đều
// suy ra từ chính đối tượng này, không chép lại danh sách khoá ở nơi thứ hai.
const FEATURE_DEFAULTS = {
  rt_quotes: false, rt_sales: false, rt_ops: false, rt_pricing: false,      // D08–D12
  rt_billing: false, rt_purchase_docs: false, rt_fees: false,               // D13–D15
  rt_stats: false, rt_commission: false, rt_plan: false, rt_contract: false, // D16–D19
  container_ops: false,                                                      // D20–D21
  approvals: false, finance: false, ar_ap: false,                            // D22–D25
  amis_push: false, portal_vendor: false, public_tracking: false,            // D26–D28
} as const

export type FeatureKey = keyof typeof FEATURE_DEFAULTS

// Khai kiểu tường minh `Record<FeatureKey, boolean>` cho biến — TS chấp nhận gán `FEATURE_DEFAULTS`
// (kiểu literal, mọi giá trị `false`) vào đây và NỚI kiểu giá trị thành `boolean` ngay tại chỗ gán,
// không cần một hàm định danh riêng. Không có bước nới này, `FEATURES.finance === true` bị TS chặn
// biên dịch (TS2367 — so sánh hai kiểu không giao nhau); Task 5 (cắt route theo cờ) cần so sánh
// này lúc runtime.
/** Module chưa xong KHÔNG được lộ ra màn nghiệm thu. Máy chủ cắt CẢ ROUTE khi cờ tắt (404). */
export const FEATURES: Record<FeatureKey, boolean> = FEATURE_DEFAULTS

const KEYS = new Set(Object.keys(FEATURES) as FeatureKey[])

/** Đọc `FEATURES=rt_sales,finance` từ biến môi trường. Tên lạ bị bỏ qua, không ném lỗi. */
export const parseFeatures = (env?: string): Set<FeatureKey> =>
  new Set(
    (env ?? '').split(',').map((s) => s.trim()).filter((s): s is FeatureKey => KEYS.has(s as FeatureKey)),
  )

/** Ngày neo của dữ liệu mẫu. KHÔNG dùng now() trong seed — tuổi nợ đổi theo ngày chạy là checklist sai số. */
export const SEED_TODAY = '2026-09-03'
